<template>
  <router-view />
</template>

<script>
export default {
    name: "Training",
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
</style>

